const style = (theme) => ({
  root: {
    background: theme.colors[1],
  },
})

export default style
